<template>
  <div
    v-if="running"
    class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-theme-background p-10"
  >
    <div class="flex w-full max-w-sm flex-col items-center">
      <div>Downloading menu for offline access...</div>
      <div class="mt-2 h-3 w-full rounded-full bg-theme-primary/50">
        <div
          class="h-full rounded-full bg-theme-primary transition-[width]"
          :style="{ width: `${percents}%` }"
        ></div>
      </div>
      <div class="mt-2">{{ percents }}%</div>
      <button
        type="button"
        class="menu-button-primary mt-16 !px-4 !py-2 !text-xs"
        @click="skip"
      >
        Skip
      </button>
    </div>
    <div class="opacity-0">
      <img
        v-for="image in queuedImages"
        :key="image.id"
        :src="image.url"
        alt=""
        class="absolute left-0 top-0 h-1 w-1"
        @load="image.done = true"
        @error="image.done = true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import isStandalone from '@menu/Utils/isStandalone';
import uniq from 'lodash/uniq';
import { computed, onMounted, ref } from 'vue';
import getRestaurant from '@menu/Utils/getRestaurant';

const images = ref<{ id: number; url: string; done: boolean }[]>([]);

const queuedImages = computed(() =>
  images.value.filter(({ done }) => !done).slice(0, 10),
);

const running = computed(() => images.value.some((image) => !image.done));

const percents = computed(() =>
  Math.ceil(
    (images.value.filter((image) => image.done).length / images.value.length) *
      100,
  ),
);

onMounted(() => {
  if (isStandalone()) {
    start();
  }
});

const restaurant = getRestaurant();

const start = () => {
  const imageUrls: (string | undefined)[] = [];

  imageUrls.push(restaurant.banner?.url);
  imageUrls.push(restaurant.logo?.url);
  imageUrls.push(restaurant.welcomePageBackground?.url);
  imageUrls.push(restaurant.fallbackProductImage?.url);

  restaurant.menus.forEach((menu) => {
    imageUrls.push(menu.homePageBackground?.url);
    imageUrls.push(menu.banner?.url);
    imageUrls.push(menu.defaultProductImage?.url);

    menu.categories.forEach((category) => {
      imageUrls.push(category.image?.thumbnailUrl);

      category.products.forEach((product) => {
        imageUrls.push(product.image?.url);
        imageUrls.push(product.image?.thumbnailUrl);
      });
    });
  });

  images.value = uniq(imageUrls)
    .filter((imageUrl): imageUrl is string => Boolean(imageUrl))
    .map((url, index) => ({
      id: index + 1,
      url,
      done: false,
    }));
};

const skip = () => {
  images.value.forEach((image) => {
    image.done = true;
  });
};
</script>
